const hy = {
  title: 'Մեր կայքը օգտագործում է cookie-ներ',
  description:
    ' Շարունակելով օգտվել մեր կայքից, դուք համաձայնվում եք cookie-ների օգտագործմանը՝ ձեր փորձառությունը բարելավելու նպատակով:',
  ok: 'Ընդունել',
};

export default hy;
